// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","badge":"Card_badge__MA8hJ","description":"Card_description__jyadU"};